import { Link, useHistory, useLocation, useParams } from 'react-router-dom'

import { FaArrowLeft } from 'react-icons/fa'

import {
  Container,
  HeaderCard,
  CardBody,
  TitleCard,
  HeaderContendCard,
  Card,
  Content,
} from './styles'
import { useSelector } from 'react-redux'
import { RootState } from '../../../../store/modules/rootReducer'
import { useEffect } from 'react'
import { useTracking } from 'react-tracking'
import { TrackingSchemaTypes } from '../../../../tracking'
import { TMessageOrigin } from '../../../../tracking/types'
import { READ_MESSAGE } from 'pages/Message/services'
import { useGetStudentMessage } from 'pages/Message/hooks/use-get-student-message'

type TLocation = {
  origin?: TMessageOrigin
}

type TParams = {
  messageId: string
}

const MessageContent = () => {
  const history = useHistory()
  const { messageId } = useParams<TParams>()
  const location = useLocation<TLocation>()

  const { trackEvent } = useTracking()

  const studentId = useSelector((state: RootState) => state.student.profile?._id)

  const swrStudentMessage = useGetStudentMessage(studentId, messageId)
  const isLoading = swrStudentMessage.isLoading || !studentId
  const studentMessage = isLoading ? '' : swrStudentMessage.data

  const loadingLine = <span className="loading-block line" />

  const loadingParagraph = (
    <>
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <br />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
      <span className="loading-block block-line" />
    </>
  )

  useEffect(() => {
    if (!studentId) return
    READ_MESSAGE(studentId, messageId)
  }, [studentId, messageId])

  useEffect(() => {
    if (!studentMessage) return

    trackEvent({
      event: TrackingSchemaTypes.MessagePageAccess,
      properties: {
        CursoNome: studentMessage.courseInfo.course.name,
        Modulo: studentMessage.courseInfo.module.name,
        Professor: studentMessage.professor.name,
        Origem: location.state?.origin || 'Outro',
      },
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [studentMessage])

  return (
    <Container>
      <HeaderCard>
        <button onClick={history.goBack} className="back-button">
          <FaArrowLeft size={12} /> Voltar
        </button>
      </HeaderCard>
      <Card>
        <CardBody>
          <TitleCard>
            <div className="header-title">
              <h3>Recado</h3>
              <p>
                Enviado em{' '}
                {isLoading ? loadingLine : new Date(studentMessage.createdAt).toLocaleDateString()}
              </p>
            </div>
          </TitleCard>
          <HeaderContendCard>
            <p>
              {isLoading ? (
                loadingLine
              ) : (
                <Link
                  to={`/course/${studentMessage.courseInfo.course._id}`}
                  className="course-name link"
                >
                  {studentMessage.courseInfo.course.name}
                </Link>
              )}{' '}
            </p>
            <p>
              <strong>Módulo: </strong>
              {isLoading ? (
                loadingLine
              ) : (
                <Link
                  to={`/course/${studentMessage.courseInfo.course._id}/module/${studentMessage.courseInfo.module._id}/lesson/${studentMessage.courseInfo.lesson._id}/chapter/${studentMessage.courseInfo.chapter._id}`}
                  className="link"
                >
                  {studentMessage.courseInfo.module.name}
                </Link>
              )}
            </p>
            <p>
              <strong>Professor: </strong>
              {isLoading ? loadingLine : studentMessage.professor.name}

              {}
            </p>
            <p>
              <strong>Assunto: </strong>
              {isLoading ? loadingLine : studentMessage.subject}
            </p>
          </HeaderContendCard>
          <div>
            <hr />
          </div>

          <Content>
            {isLoading ? (
              loadingParagraph
            ) : (
              <div dangerouslySetInnerHTML={{ __html: studentMessage.message }}></div>
            )}
          </Content>
        </CardBody>
      </Card>
    </Container>
  )
}

export default MessageContent
